import TableServicesIpRestrictionsContainer from './TableServicesIpRestrictions.container';
export default TableServicesIpRestrictionsContainer;
